<scitis-app-global-page-header [pageTitle]="'Organization administration'">

  <ng-template #entryCount>
    <div class="page-header-counts">
      <div class="count">
        <span class="badge badge-pill badge-primary" [innerText]="organizationCount"></span>
        <span class="count-label" translate>Organizations</span>
      </div>
    </div>
  </ng-template>

  <ng-template #filterElement>
    <div class="search">
      <input class="form-control" type="search"
             [(ngModel)]="searchTerm" (change)="onSearch($event)"
             [placeholder]=" ('Search organization' | translate) + '...'">
    </div>
  </ng-template>

  <ng-template #filterElement>
    <button class="btn btn-primary"
            (click)="onAddOrganization()"
            [disabled]="(!isAdminRole && !isSuperAdminRole) || restrictOrganizationInteraction">
      <span class="fa-solid fa-plus"></span>
      <span translate>New organization</span>
    </button>
  </ng-template>

</scitis-app-global-page-header>


<div class="card card-table-view mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
        <tr>

          <th scope="col" class="sortable" sortable="name" (sort)="onColumnSort($event)">
            <span translate>Dataset name</span>
          </th>
          <th scope="col" class="sortable" sortable="description" (sort)="onColumnSort($event)">
            <span translate>Display name</span>
          </th>
          <th scope="col" class="sortable" sortable="parentTenantName" (sort)="onColumnSort($event)">
            <span translate>Parent</span>
          </th>
          <th scope="col" class="sortable" sortable="tableauSite" (sort)="onColumnSort($event)">
            <span translate>Tableau Site</span>
          </th>

          <th scope="col">
            <span translate>Tableau User Name</span>
          </th>

          <th scope="col">
            <span translate>Tableau URL</span>
          </th>

          <th scope="col" class="text-right">
            <span translate>Action</span>
          </th>
        </tr>
        </thead>
        <tbody>

        <tr
          *ngFor="let organization of organizationsList | paginate: paginateSettings; index as i">
          <td>
            <ngb-highlight [result]="organization.name" title="{{organization.name}}"
                           class="font-weight-bold truncate truncate-lg" [term]="searchTerm"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="organization.description" title="{{organization.description}}" [term]="searchTerm"
                           class="truncate truncate-lg"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="organization.parentTenantName" [term]="searchTerm"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="organization?.tableauConfiguration?.siteName" [term]="searchTerm"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="organization?.tableauConfiguration?.userName" [term]="searchTerm"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="organization?.tableauConfiguration?.url" [term]="searchTerm"></ngb-highlight>
          </td>
          <td class="text-right">
            <scitis-admin-organization-action [organization]="organization"
                                              [searchTerm]="searchTerm"
                                              [restrictOrganizationInteraction]="restrictOrganizationInteraction"
                                              [rootOrganizationId]="rootOrganizationId"
                                              [isSuperAdminRole]="isSuperAdminRole"
                                              [isAdminRole]="isAdminRole"
                                              (organizationDeleteEvent)="onDeleteOrganizationSuccess(organization)">

            </scitis-admin-organization-action>
          </td>
        </tr>
        </tbody>
      </table>
      <div *ngIf="organizationsList.length === 0"
           class="d-flex align-items-center justify-content-center mb-0 mt-3 alert alert-info text-center">
        <em class="fa-solid fa-circle-info mr-2"></em>
        <span translate>No organizations found for searched term and filters.</span>
      </div>
    </div>
  </div>
</div>

<scitis-ngx-pagination [id]="paginateSettings.id"
                       paginationClass="col"
                       [itemsPerPage]="paginateSettings.itemsPerPage"
                       [itemsPerPageOptions]="itemsPerPageOptions"
                       (itemsPerPageChange)="onItemsPerPageChange($event)"
                       (pageNumberChange)="onLoadPageNumber($event)">
</scitis-ngx-pagination>
